import { useAtom } from 'jotai';
import firebase from 'firebase';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { Element4, User, Calendar, MessageTime, ClipboardText, Star, Setting2 } from 'iconsax-react';
import { userRecordAtom } from '../../../../../shared/state/atoms';
import { PATH_PROVIDER } from '../../../../../shared/routes/paths';
import { firestoreKeys, jobStatuses, quoteStatuses } from '../../../../../shared/utils/constants';

export default function useProviderNav() {
  const [user] = useAtom(userRecordAtom);
  const hasBankingDetails = Boolean(user?.paymentDetails?.paystackSubaccountCode);

  const [bookings] = useCollectionData(
    user && user.id
      ? firebase
          .firestore()
          .collection(firestoreKeys.QUOTES)
          .where('customer.id', '==', user.id)
          .orderBy('meta.createdDate', 'desc')
      : null,
    { idField: 'id' }
  );
  const bookingsList = bookings?.filter((booking) => booking.status !== quoteStatuses.CANCELLED);

  const hasExpiredBookings =
    bookingsList?.some((booking) => {
      const endTime = booking?.date?.endTime?.toDate?.() || new Date(booking?.date?.endTime);
      const now = new Date();
      return (
        endTime && endTime < now && [jobStatuses.PENDING, jobStatuses.AWAITING_CUSTOMER].includes(booking.jobStatus)
      );
    }) || false;

  const baseItems = [
    { title: 'Dashboard', path: PATH_PROVIDER.dashboard, icon: <Element4 /> },
    { title: 'My Profile', path: PATH_PROVIDER.profile, icon: <User /> },
  ];

  const bankingRequiredItems = [
    { title: 'My Calendar', path: PATH_PROVIDER.calendar, icon: <Calendar /> },
    { title: 'My Bookings', path: PATH_PROVIDER.bookings.root, icon: <MessageTime /> },
    { title: 'My Listings', path: PATH_PROVIDER.listings.root, icon: <ClipboardText /> },
    { title: 'My Quotes', path: PATH_PROVIDER.quotes.root, icon: <MessageTime /> },
    { title: 'Reviews', path: PATH_PROVIDER.reviews, icon: <Star /> },
    { title: 'My Subscription', path: PATH_PROVIDER.manageSubscription, icon: <Setting2 /> },
  ];

  return {
    providerNavItems: hasBankingDetails ? [...baseItems, ...bankingRequiredItems] : baseItems,
    hasExpiredBookings,
  };
}
